/** Registers the ParallaxBackground parser. */
import { nodeRegistry } from '../../../core/NodeRegistry';
import { parseParallaxBackground } from './parser';
const parallaxBackgroundRegistration = {
    typeName: 'ParallaxBackground',
    parser: parseParallaxBackground,
};
nodeRegistry.register(parallaxBackgroundRegistration);
export * from './parser';
export * from './types';
//# sourceMappingURL=index.js.map